<script setup lang="ts">
import ConsumerTrends from "@/views/playground/planner/business-management/statistics/ConsumerTrends.vue";
</script>

<template>
  <consumer-trends></consumer-trends>
</template>

<style scoped></style>
